import { FragileLogo } from 'components/_const_assets/fragileLogo'
import { BenefitProps } from 'components/_utils/utilityTypes'
import { Icon } from 'components/Phantom/Icon'
import { Type } from 'components/Type'
import { FC } from 'react'
import styles from './FragileModal.module.scss'
import { FragileModalProps } from './FragileModal.types'

export const FragileModalConnected: FC = () => {
	return <FragileModal />
}

export const FragileModal: FC<FragileModalProps> = () => {
	return (
		<div className={styles.container}>
			<header className={styles.header}>
				<Type.Headline4>Renting the Pod</Type.Headline4>

				<Type.Body2 className={styles.badge}>
					Powered by <FragileLogo color="#7d7d7d" /> <span className="vh">Fragile</span>
				</Type.Body2>

				<Type.Body2 className={styles.description}>
					Starting at $159/mo, get the full experience of the Pod 4 and Autopilot, without long-term commitments. Whether you're not yet at your forever home, or will be changing beds soon, you can
					opt to rent the Pod to keep things flexible.
				</Type.Body2>
			</header>
			<Benefits />
			<FAQ />
		</div>
	)
}

const Benefits: FC = () => {
	const benefits: BenefitProps[] = [
		{
			icon: 'CalendarLight',
			text: 'Rent for as long as you’d like',
		},
		{
			icon: 'CloseCircleLight',
			text: 'Cancel anytime',
		},
		{
			icon: 'WarrantyLight',
			text: 'Ongoing warranty*',
		},
		{
			icon: 'EightBoxLight',
			text: 'Free shipping, both ways',
		},
		{
			icon: 'CreditCardLight',
			text: 'No impact to credit',
		},
	]

	return (
		<article className={styles.benefits}>
			<ul className={styles.benefits_list}>
				{benefits.map((benefit) => (
					<li key={benefit.text}>
						<Icon
							name={benefit.icon}
							color={'black'}
						/>
						<Type.Body2>{benefit.text}</Type.Body2>
					</li>
				))}
			</ul>
			<Type.SmallPrint className={styles.disclaimer}>*Requires active rental agreement.</Type.SmallPrint>
		</article>
	)
}

const FAQ: FC = () => {
	const FAQs = [
		{
			question: 'How does renting the Pod work?',
			answer: 'Rent the Pod 4 with Autopilot for a flat monthly fee—no commitments, cancel anytime by returning it. If your device breaks or has issues, we’ll fix or replace it.',
		},
		{
			question: 'How is renting different from financing?',
			answer: 'Renting the Pod is not a financing or a rent-to-own program, which means you won’t own the device after a certain date.',
		},
		{
			question: 'How does cancelling work?',
			answer:
				'You may cancel your rental plan at any time by contacting us. We will send you a pre-paid return label and pause any rental plan payments for 7 days to give you enough time to pack and ship your item before your next billing date. We do not offer partial refunds for unused days remaining on your rental plan. If you don’t return your item, your monthly rental payments will continue as normal.',
		},
		{
			question: 'Who is eligible to rent the Pod?',
			answer:
				'To enter into a rental agreement, you must be at least 18 years old. A valid U.S. government-issued ID is required to verify your age and identity. You must also reside within the contiguous 48 United States, as we do not offer rental plans in Alaska, Hawaii, U.S. Territories, or locations outside of the U.S.',
		},
	]

	return (
		<article className={styles.faqs}>
			<ul className={styles.faqs_list}>
				{FAQs.map((faq) => (
					<li key={faq.question}>
						<Type.Body1>{faq.question}</Type.Body1>
						<Type.Body1 className={styles.answer}>{faq.answer}</Type.Body1>
					</li>
				))}
			</ul>
			<Type.SmallPrint className={styles.disclaimer}>**Latest version model will be determined at time of upgrade</Type.SmallPrint>
		</article>
	)
}
